import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "userLoginView" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { style: {"margin-bottom":"16px"} }, "用户登录", -1)
const _hoisted_3 = { style: {"text-align":"center"} }

import { reactive, ref } from "vue";
import { UserControllerService, UserLoginRequest } from "../../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserLoginView',
  setup(__props) {

const form = reactive({
  userAccount: "",
  userPassword: "",
} as UserLoginRequest);

const router = useRouter();
const route = useRoute();
const store = useStore();
const loading = ref(false);

const handleSubmit = async () => {
  loading.value = true;
  try {
    const res = await UserControllerService.userLoginUsingPost(form);
    if (res.code === 0) {
      await store.dispatch("user/getLoginUser");
      const redirect = (route.query.redirect as string) || "/";
      router.push({ path: redirect, replace: true });
    } else {
      message.error("登录失败，" + res.message);
    }
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_form, {
      style: {"max-width":"480px","margin":"0 auto"},
      "label-align": "left",
      "auto-label-width": "",
      model: form,
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "userAccount",
          label: "账号",
          "hide-label": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.userAccount,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.userAccount) = $event)),
              placeholder: "请输入账号"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userPassword",
          label: "密码",
          "hide-label": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: form.userPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.userPassword) = $event)),
              placeholder: "请输入密码"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              long: "",
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 登录 ")
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(" 没有账号？ "),
          _createVNode(_component_a_link, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/user/register')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("立即注册")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})